import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { HELP_DESK_URL } from '../constants/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HelpDeskInterceptAlert = ({
  onDismiss,
  onClickGoToHelpDesk
}) => {
  return /*#__PURE__*/_jsx(UIAlert, {
    "data-test-id": "help-desk-intercept-alert",
    type: "info",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "uiAddonConversationsSettings.helpDeskOnboarding.helpDeskIntercept.alert.title"
    }),
    closeable: true,
    onClose: onDismiss,
    children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "uiAddonConversationsSettings.helpDeskOnboarding.helpDeskIntercept.alert.description"
      }), /*#__PURE__*/_jsx(UIButton, {
        size: "extra-small",
        use: "tertiary",
        href: HELP_DESK_URL,
        onClick: onClickGoToHelpDesk,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "uiAddonConversationsSettings.helpDeskOnboarding.helpDeskIntercept.alert.button"
        })
      })]
    })
  });
};
HelpDeskInterceptAlert.displayName = 'HelpDeskInterceptAlert';